import { gsap } from 'gsap';
import App from '@templates/App/App.js';

const MenuDropdown = {
	hideSelected: true,

	init(header) {
		const menu = header.find('[module="structure"][method="renderMenu"]');
		menu.find('.dropdown').each((i, el) => {
			const li = $(el).closest('li');
			this.bind(li);
		});
	},

	bind(li) {

		li.unbind('mouseenter').mouseenter((evt) => {
			const li = $(evt.currentTarget);
			const selected = li.siblings('.selected');
			// if (li.is('.selected')) return;
			if (App.isTouchable) return;

			this.show(li);
			if (selected && selected.length) {
				this.hide(selected);
			}
		});

		li.unbind('mouseleave').mouseleave((evt) => {
			const li = $(evt.currentTarget);
			// if (li.is('.selected')) return;
			if (App.isTouchable) return;

			this.hide(li);
		});
	},

	show(li) {
		const dropdown = li.find('> ul.dropdown');
		gsap.set(dropdown, { display: 'flex', height: 'auto' });
		gsap.from(dropdown, {
			height: 0, overwrite: true, ease: 'power4.inOut', onComplete: () => {
				dropdown.css({ overflow: 'visible' });
			},
		});
		li.children('a').addClass('hover');
	},

	hide(li) {
		const dropdown = li.find('> ul.dropdown');
		dropdown.css({ overflow: 'hidden' });
		console.log(dropdown);
		gsap.to(dropdown, { height: 0, overwrite: true, display: 'none', ease: 'power4.inOut' });
		li.children('a').removeClass('hover');
	},

};

export default MenuDropdown;